// useUndoContext — UndoStack Context 정의 + hook (U53).
//
// UndoStackProvider를 App.tsx에서 한 번 마운트하면 하위 모든 컴포넌트에서
// useUndoContext()로 push/undoLast/clear/current에 접근 가능.

import { createContext, useContext } from 'react';
import type { UndoStackValue } from './useUndoStack';

/** UndoStack Context — null은 Provider 외부에서 접근 시 에러 처리용 */
export const UndoContext = createContext<UndoStackValue | null>(null);

/**
 * useUndoContext — UndoStack 접근 훅.
 * UndoStackProvider 하위에서만 사용 가능.
 */
export function useUndoContext(): UndoStackValue {
  const ctx = useContext(UndoContext);
  if (!ctx) {
    throw new Error('useUndoContext must be used within UndoStackProvider');
  }
  return ctx;
}
